
import { useTranslation } from "react-i18next";
import { useLocation,Navigate,useNavigate } from 'react-router-dom';
import { getCustomer, getUser } from "../../helpers/auth-helper";
import { getData } from "../../helpers/api-helper";
import { useEffect, useState } from "react";
import { Button, PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap";
import { usePage } from "../../helpers/page-context";

const ProtectedRoute = ({ children }) => {

	const user = getUser();
	const version = getConfig('VERSION');

	version.then((res) => 
		{
			if(res !== process.env.REACT_APP_VERSION){
				caches.delete()
				caches.keys().then(function(cacheNames) {
					cacheNames.forEach(function(cacheName) {
						caches.delete(cacheName);
					});
				});
				window.location.reload(true);
				console.log("Changing Version to", version)
			}
		}
	)

	if (!user) {
		return <Navigate to="/login" replace={true} />;
	}else{
		return (
			<>
				<Sidebar/>
				<div class="background-page py-6 px-5 sm:ml-64">
					{children}
				</div>
			</>
		);
	}
};

const getConfig=async(name)=>{
	const response = await getData(process.env.REACT_APP_API+"/get_configurations",{name})
	if(response?.data){
		return response?.data.config.value
	}
}

const Sidebar =()=>{
    const { i18n, t } = useTranslation();
    const navigate = useNavigate()
	const location = useLocation();
	const { pathname } = location;
	const [wa,set_wa] = useState("")

	useEffect(() => {
		getCustomerSupport()
		console.log('hit protected')
		// Create the first script element for qchatInitialize.js
		const qchatInit = document.createElement('script');
		qchatInit.src = "https://webchat.qontak.com/qchatInitialize.js";
	
		// Create the second script element for app.js
		const qchatWidget = document.createElement('script');
		qchatWidget.src = "https://webchat.qontak.com/js/app.js";
	
		// Append scripts to document head
		document.head.prepend(qchatInit);
		document.head.prepend(qchatWidget);
	
		// Set up initialization after qchatInit has loaded
		qchatInit.onload = function() {
			if (window.qchatInitialize) {
				var qchat_user = JSON.stringify({
					email:"naufall.musyaffa@gmail.com",
					name:"naufal",
					phone_number:"+6285719589131",
					widget_id:"24c61981-6d4a-434d-adb7-625ad03452f7"
				})
				localStorage.setItem("qchat_user",qchat_user)
				window.qchatInitialize({
					id: "24c61981-6d4a-434d-adb7-625ad03452f7", 
					code: "Q2Hh1RRnpjRdST61JSj8sg",
					user:qchat_user
				});
				// window.qchatInitialize({
				// 	id: "ff254a01-87ab-4eef-9788-48eff8096ccf",
				// 	code: "33lxjP6JlmObxcOwreFomQ",
				// });
			}
		};
	
		// Clean up script tags on unmount
		return () => {
		  document.head.removeChild(qchatInit);
		  document.head.removeChild(qchatWidget);
		};
	},[])

	const simulateInputChange = () => {
		const iframe = document.querySelector("iframe");
		if (iframe) {
		  const textbox = iframe.contentWindow.document.querySelector("textarea[placeholder='Type your message here']");
		  	if (textbox) {
				textbox.dispatchEvent(new Event("focus")); // Focus the textbox
				textbox.value = "Hello from React!";
				textbox.dispatchEvent(new Event("input")); // Trigger input event
	  		}
	  	}
	  };

	const {notifications,set_notifications} = usePage()
	const storage_notification = localStorage.getItem('notifications')
	const [notif,set_notif] = useState(JSON.parse(storage_notification))

	useEffect(() => {
		if(notifications.length > 0){
			set_notif(notifications)
		}
		console.log('notif baru',notifications)
		console.log('notif lama',notif)
	},[notifications])
	
	const getCustomerSupport = async ()=>{

		const response = await getData(`${process.env.REACT_APP_API}/customer-support`,{paginate:99,page:1})

		if(response){
            if(response?.data){
                var WA = response.data.data.data.filter(item => item.type == 'WhatsApp');
				set_wa(WA[0]?.value)
			}
		}
	}
    
    const readNotification=(url)=>{
        var deleted = notif.filter(item => {return!(item.fcmOptions.link == url)})
        localStorage.setItem('notifications',JSON.stringify(deleted))
        set_notifications(deleted)
        set_notif(deleted)
    }

	const clickNotif=(url)=>{
		readNotification(url)
		var pathname = url.slice(process.env.REACT_APP_WEB_URL.length,9999);
		console.log(pathname)
		navigate(pathname)
		// return <Navigate to={pathname} replace={true} />;
	}

	return(
		<aside id="default-sidebar" class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar">
			<div class="h-full px-3 py-4 overflow-y-auto bg-gray-50 white">
				<ul class="space-y-5 font-medium">
					<li className="flex justify-center">
						<img src={process.env.PUBLIC_URL + '/logosmall.png'} className="App-logo-small" alt="logo" />
						<span class="ms-3">{t('title')}</span>
					</li>
					<li className={pathname == '/dashboard' ? "bg-gray-200 rounded-lg" : ""}>
						<a href="/dashboard" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 group hover:bg-gray-100 dark:hover:bg-gray-200">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.375 18.329H17.625M11.13 1.015L1.38 7.60899C1.18778 7.73642 1.02979 7.90913 0.919937 8.11192C0.810086 8.31471 0.75173 8.54138 0.75 8.772V21.113C0.766496 21.6943 1.01243 22.2453 1.43405 22.6458C1.85567 23.0462 2.41868 23.2634 3 23.25H21C21.5817 23.2634 22.145 23.0459 22.5666 22.6451C22.9883 22.2442 23.234 21.6926 23.25 21.111V8.771C23.2483 8.54037 23.1899 8.3137 23.0801 8.11092C22.9702 7.90813 22.8122 7.73543 22.62 7.608L12.87 1.01401C12.6126 0.84169 12.3098 0.749695 12 0.749695C11.6902 0.749695 11.3874 0.842682 11.13 1.015Z" stroke="#1D1B20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span class="ms-3">{t('sidebar.dashboard')}</span>
						</a>
					</li>
					<li className={pathname == '/my-device' ? "bg-gray-200 rounded-lg" : ""}>
						<a href="/my-device" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-200 group">
							<svg width="24" height="24" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M23.375 15.5C23.375 15.7984 23.4935 16.0845 23.7045 16.2955C23.9155 16.5065 24.2016 16.625 24.5 16.625C24.7984 16.625 25.0845 16.5065 25.2955 16.2955C25.5065 16.0845 25.625 15.7984 25.625 15.5H23.375ZM2.375 15.5C2.375 15.7984 2.49352 16.0845 2.7045 16.2955C2.91548 16.5065 3.20163 16.625 3.5 16.625C3.79837 16.625 4.08452 16.5065 4.2955 16.2955C4.50648 16.0845 4.625 15.7984 4.625 15.5H2.375ZM6.125 2.37501H21.875V0.125009H6.125V2.37501ZM23.375 3.788V15.5H25.625V3.788H23.375ZM4.625 15.5V3.788H2.375V15.5H4.625ZM21.875 2.37501C22.2612 2.3637 22.6362 2.50617 22.9174 2.77111C23.1987 3.03605 23.3632 3.40179 23.375 3.788H25.625C25.6134 2.805 25.2118 1.86686 24.5086 1.17992C23.8053 0.492993 22.858 0.113537 21.875 0.125009V2.37501ZM6.125 0.125009C5.14199 0.113537 4.19469 0.492993 3.49144 1.17992C2.78819 1.86686 2.3866 2.805 2.375 3.788H4.625C4.63676 3.40179 4.80134 3.03605 5.0826 2.77111C5.36385 2.50617 5.73877 2.3637 6.125 2.37501V0.125009ZM3.5 17.375H24.5V15.125H3.5V17.375ZM24.875 17.75V19.25H27.125V17.75H24.875ZM24.5 19.625H3.5V21.875H24.5V19.625ZM3.125 19.25V17.75H0.875V19.25H3.125ZM3.5 19.625C3.40054 19.625 3.30516 19.5855 3.23483 19.5152C3.16451 19.4449 3.125 19.3495 3.125 19.25H0.875C0.875265 19.9461 1.15191 20.6136 1.64413 21.1059C2.13636 21.5981 2.80389 21.8747 3.5 21.875V19.625ZM24.875 19.25C24.875 19.3495 24.8355 19.4449 24.7652 19.5152C24.6948 19.5855 24.5995 19.625 24.5 19.625V21.875C25.1961 21.8747 25.8636 21.5981 26.3559 21.1059C26.8481 20.6136 27.1247 19.9461 27.125 19.25H24.875ZM24.5 17.375C24.5995 17.375 24.6948 17.4145 24.7652 17.4848C24.8355 17.5552 24.875 17.6506 24.875 17.75H27.125C27.1247 17.0539 26.8481 16.3864 26.3559 15.8941C25.8636 15.4019 25.1961 15.1253 24.5 15.125V17.375ZM3.5 15.125C2.80389 15.1253 2.13636 15.4019 1.64413 15.8941C1.15191 16.3864 0.875265 17.0539 0.875 17.75H3.125C3.125 17.6506 3.16451 17.5552 3.23483 17.4848C3.30516 17.4145 3.40054 17.375 3.5 17.375V15.125Z" fill="#1D1B20"/>
							</svg>
							<span class="ms-3">{t('sidebar.my_device')}</span>
						</a>
					</li>
					<li className={pathname == '/promo' ? "bg-gray-200 rounded-lg" : ""} onClick={() => window.open('https://www.advan.id/shop-2/')}>
						<a href="#" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-200 group">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.99998 13.25L4.77098 20.336C4.82098 20.536 4.84599 20.636 4.87099 20.721C5.01204 21.1368 5.27159 21.5024 5.61769 21.7726C5.96379 22.0428 6.38136 22.206 6.81898 22.242C6.91098 22.25 7.01298 22.25 7.21898 22.25C7.47698 22.25 7.60599 22.25 7.71399 22.24C8.23323 22.1898 8.71885 21.9606 9.08772 21.5917C9.45659 21.2229 9.68575 20.7372 9.73598 20.218C9.74598 20.11 9.74599 19.981 9.74599 19.723V3.68801M19.309 12.688C20.3424 12.6715 21.3279 12.2495 22.0529 11.5128C22.7779 10.7762 23.1842 9.78406 23.1842 8.75051C23.1842 7.71695 22.7779 6.72483 22.0529 5.98819C21.3279 5.25156 20.3424 4.82948 19.309 4.81301M10.027 3.68801H5.80899C4.47865 3.70671 3.20914 4.2483 2.27499 5.19567C1.34085 6.14304 0.817139 7.42004 0.817139 8.75051C0.817139 10.081 1.34085 11.358 2.27499 12.3053C3.20914 13.2527 4.47865 13.7943 5.80899 13.813H10.029C12.2576 14.0224 14.4093 14.7365 16.321 15.901C17.421 16.501 17.962 16.795 18.321 16.751C18.4768 16.7359 18.6274 16.6867 18.762 16.6068C18.8966 16.527 19.012 16.4185 19.1 16.289C19.31 15.995 19.31 15.409 19.31 14.232V3.26801C19.31 2.09201 19.31 1.505 19.1 1.211C19.012 1.08152 18.8966 0.973009 18.762 0.893162C18.6274 0.813314 18.4768 0.764102 18.321 0.749012C17.963 0.706012 17.421 1.004 16.321 1.599C14.4097 2.76378 12.2584 3.47817 10.03 3.68801H10.027Z" stroke="#1D1B20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>

							<span class="ms-3">{t('sidebar.interesting_promo')}</span>
						</a>
					</li>
					<li className={pathname == '/news' ? "bg-gray-200 rounded-lg" : ""}>
						<a href="/news" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-200 group">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10.75 1.99899H6.75C4.65 1.99899 3.6 1.999 2.798 2.409C2.09253 2.76872 1.51859 3.34196 1.158 4.047C0.750005 4.847 0.75 5.89999 0.75 7.99899V17.25C0.75 19.35 0.750005 20.4 1.158 21.203C1.51859 21.9083 2.09249 22.4819 2.798 22.842C3.598 23.25 4.65 23.25 6.75 23.25H16.001C18.101 23.25 19.151 23.25 19.953 22.842C20.6579 22.4817 21.2311 21.9081 21.591 21.203C22.001 20.403 22.001 19.35 22.001 17.25V13.25M22.152 1.85001C22.6772 2.37433 23.0352 3.04267 23.1804 3.77048C23.3257 4.49828 23.2518 5.25282 22.9681 5.93861C22.6844 6.62441 22.2036 7.21062 21.5866 7.62308C20.9696 8.03554 20.2442 8.25571 19.502 8.25571C18.7598 8.25571 18.0344 8.03554 17.4174 7.62308C16.8004 7.21062 16.3196 6.62441 16.0359 5.93861C15.7522 5.25282 15.6783 4.49828 15.8236 3.77048C15.9688 3.04267 16.3268 2.37433 16.852 1.85001C17.5553 1.14885 18.5079 0.755127 19.501 0.755127C20.4941 0.755127 21.4467 1.14885 22.15 1.85001H22.152Z" stroke="#1D1B20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>

							<span class="ms-3">{t('sidebar.news')}</span>
						</a>
					</li>
					{/* <li className={pathname == '/customer-service' ? "bg-gray-200 rounded-lg" : ""} onClick={() => window.open("https://wa.me/"+wa+"?text=Hallo")}> */}
					<li className={pathname == '/customer-service' ? "bg-gray-200 rounded-lg" : ""}>
						<a href="/customer-service" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-200 group">
						<svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.61798 13.033C6.38024 11.5104 6.49524 9.95352 6.95412 8.48235C7.413 7.01119 8.20352 5.66502 9.26474 4.54757C10.326 3.43012 11.6296 2.5712 13.0751 2.03704C14.5206 1.50289 16.0695 1.30776 17.6024 1.46664C19.1352 1.62552 20.6111 2.13418 21.9164 2.95345C23.2216 3.77273 24.3214 4.88075 25.1308 6.1921C25.9403 7.50345 26.4379 8.98314 26.5853 10.5171C26.7327 12.0511 26.5259 13.5985 25.981 15.04C25.921 15.1811 25.8706 15.3261 25.83 15.474C25.8113 15.553 25.8016 15.6338 25.801 15.715C25.8029 15.8467 25.8146 15.978 25.836 16.108L26.336 20.195C26.4063 20.4651 26.4094 20.7484 26.345 21.02C26.2805 21.1606 26.1661 21.2721 26.024 21.333C25.7509 21.3913 25.4677 21.3821 25.199 21.306L21.218 20.723C21.0838 20.699 20.9482 20.684 20.812 20.678C20.7279 20.6772 20.644 20.6863 20.562 20.705C20.4092 20.7459 20.2592 20.7966 20.113 20.857C18.4898 21.4612 16.7394 21.6419 15.027 21.382M8.53798 26.497C9.90514 26.5312 11.2515 26.157 12.4049 25.4222C13.5583 24.6875 14.4665 23.6254 15.0133 22.3719C15.5601 21.1184 15.7208 19.7303 15.4748 18.3851C15.2288 17.0398 14.5873 15.7984 13.6322 14.8195C12.6771 13.8407 11.4519 13.1689 10.1131 12.8898C8.77426 12.6108 7.38263 12.7373 6.11606 13.2531C4.84948 13.7689 3.76548 14.6507 3.00255 15.7857C2.23962 16.9207 1.83241 18.2574 1.83298 19.625C1.83232 20.3666 1.94876 21.1037 2.17798 21.809C2.24222 21.9834 2.295 22.1618 2.33598 22.343C2.35193 22.4307 2.35663 22.5201 2.34998 22.609C2.33411 22.7575 2.30704 22.9046 2.26898 23.049L1.50598 26.5L5.24797 25.988C5.38038 25.9667 5.51397 25.9533 5.64798 25.948C5.72731 25.9469 5.80649 25.9549 5.88397 25.972C6.04635 26.0149 6.20626 26.0666 6.36298 26.127C7.06225 26.3738 7.79845 26.4995 8.53998 26.499L8.53798 26.497Z" stroke="#1D1B20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>

							<span class="ms-3">{t('sidebar.customer_service')}</span>
						</a>
					</li>
					<li className={pathname == '/service-center' ? "bg-gray-200 rounded-lg" : ""}>
						<a href="/service-center" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-200 group">
						<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"></path></svg>
							<span class="ms-3">{t('sidebar.service_center')}</span>
						</a>
					</li>
					<li className={pathname == '/settings' ? "bg-gray-200 rounded-lg" : ""}>
						<a href="/settings" class="flex items-center p-2 text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-200 group">
							<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2.21232 14.0601C1.91928 12.6755 1.93115 11.2743 2.21316 9.94038C3.32308 10.0711 4.29187 9.7035 4.60865 8.93871C4.92544 8.17392 4.50032 7.22896 3.62307 6.53655C4.3669 5.3939 5.34931 4.39471 6.53554 3.62289C7.228 4.50059 8.17324 4.92601 8.93822 4.60914C9.7032 4.29227 10.0708 3.32308 9.93979 2.21281C11.3243 1.91977 12.7255 1.93164 14.0595 2.21364C13.9288 3.32356 14.2964 4.29235 15.0612 4.60914C15.8259 4.92593 16.7709 4.5008 17.4633 3.62356C18.606 4.36739 19.6052 5.3498 20.377 6.53602C19.4993 7.22849 19.0739 8.17373 19.3907 8.93871C19.7076 9.70369 20.6768 10.0713 21.7871 9.94028C22.0801 11.3248 22.0682 12.726 21.7862 14.06C20.6763 13.9293 19.7075 14.2969 19.3907 15.0616C19.0739 15.8264 19.4991 16.7714 20.3763 17.4638C19.6325 18.6064 18.6501 19.6056 17.4638 20.3775C16.7714 19.4998 15.8261 19.0743 15.0612 19.3912C14.2962 19.7081 13.9286 20.6773 14.0596 21.7875C12.675 22.0806 11.2738 22.0687 9.93989 21.7867C10.0706 20.6768 9.70301 19.708 8.93822 19.3912C8.17343 19.0744 7.22848 19.4995 6.53606 20.3768C5.39341 19.633 4.39422 18.6506 3.62241 17.4643C4.5001 16.7719 4.92552 15.8266 4.60865 15.0616C4.29179 14.2967 3.32259 13.9291 2.21232 14.0601ZM3.99975 12.2104C5.09956 12.5148 6.00718 13.2117 6.45641 14.2963C6.90564 15.3808 6.75667 16.5154 6.19421 17.5083C6.29077 17.61 6.38998 17.7092 6.49173 17.8056C7.4846 17.2432 8.61912 17.0943 9.70359 17.5435C10.7881 17.9927 11.485 18.9002 11.7894 19.9999C11.9295 20.0037 12.0697 20.0038 12.2099 20.0001C12.5143 18.9003 13.2112 17.9927 14.2958 17.5435C15.3803 17.0942 16.5149 17.2432 17.5078 17.8057C17.6096 17.7091 17.7087 17.6099 17.8051 17.5081C17.2427 16.5153 17.0938 15.3807 17.543 14.2963C17.9922 13.2118 18.8997 12.5149 19.9994 12.2105C20.0032 12.0704 20.0033 11.9301 19.9996 11.7899C18.8998 11.4856 17.9922 10.7886 17.543 9.70407C17.0937 8.61953 17.2427 7.48494 17.8052 6.49204C17.7086 6.39031 17.6094 6.2912 17.5076 6.19479C16.5148 6.75717 15.3803 6.9061 14.2958 6.4569C13.2113 6.0077 12.5144 5.10016 12.21 4.00044C12.0699 3.99666 11.9297 3.99659 11.7894 4.00024C11.4851 5.10005 10.7881 6.00767 9.70359 6.4569C8.61904 6.90613 7.48446 6.75715 6.49155 6.1947C6.38982 6.29126 6.29071 6.39047 6.19431 6.49222C6.75668 7.48509 6.90561 8.61961 6.45641 9.70407C6.00721 10.7885 5.09967 11.4855 3.99995 11.7899C3.99617 11.93 3.9961 12.0702 3.99975 12.2104ZM11.9997 15.0002C10.3428 15.0002 8.99969 13.657 8.99969 12.0002C8.99969 10.3433 10.3428 9.00018 11.9997 9.00018C13.6565 9.00018 14.9997 10.3433 14.9997 12.0002C14.9997 13.657 13.6565 15.0002 11.9997 15.0002ZM11.9997 13.0002C12.552 13.0002 12.9997 12.5525 12.9997 12.0002C12.9997 11.4479 12.552 11.0002 11.9997 11.0002C11.4474 11.0002 10.9997 11.4479 10.9997 12.0002C10.9997 12.5525 11.4474 13.0002 11.9997 13.0002Z"></path></svg>
							<span class="ms-3">{t('sidebar.settings')}</span>
						</a>
					</li>
				</ul>
				<div className="w-16 mt-20">
					{	notif?.length > 0 &&
						<div className="w-6 h-6 fixed bottom-26 left-12 rounded-full" style={{backgroundColor:"#EB008B"}}>
							<label className="text-sm text-white m-auto">
								{notif.length}
							</label>
						</div>
					}
					<Button id="PopoverClick" style={{width:'95%'}}>
						<svg className="self-center mx-auto" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM18 17V10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V17H18ZM9 21H15V23H9V21Z"></path></svg>							
					</Button>
					<UncontrolledPopover
					placement="top"
					target="PopoverClick"
					trigger="click">
						<PopoverBody className="bg-white w-60 ml-2 rounded-lg border-2 border-solid border-gray-500">
							<h4 className="text-center">{t('sidebar.notifications')}</h4>
							{notif?.length > 0 ? notif.map((row) => (
								<div onClick={() => clickNotif(row.fcmOptions.link)} className={"p-3 w-50 text-left rounded bg-white mr-2 cursor-pointer break-inside-avoid"}>
									{/* <a href={row.fcmOptions.link}> */}
										<div className="">
											<h3 className="font-bold line-clamp-2">{row.notification.title}</h3>
											<p className="text-xs font-semibold line-clamp-3">{row.notification.body}</p>
											{/* <p className="mt-2 text-xs text-gray-500">{moment(row.created_at).format('LLLL')}</p> */}
										</div>
									{/* </a> */}
									<hr></hr>
								</div>
							))
							:
							<h4 className="text-center">{t('empty')}</h4>
							}
						</PopoverBody>
					</UncontrolledPopover>
				</div>
			</div>
		</aside>
	)
}

export default ProtectedRoute;
